// This file contains functionality used on the info page for the physical store - https://www.dpj.se/content/73-butik

import { modals } from './modals';

export const store = {
    init: () => {
        console.debug("store.js: init");
        $(".store-wrapper").on("click", ".input-button", store.renderCalendar);
    },
    renderCalendar: () => {
        if (!$("#store-calendar-modal").length) {
            modals.ol.append(`
                <div class="modal-box" id="store-calendar-modal">
                    <i class="fas fa-times-circle close-modal"></i>
                    <div class="calendly-inline-widget" data-url="https://calendly.com/dpj-workspace/butik" style="min-width:100%;height:400px;"></div>
                    <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js"></script>
                </div>
            `);
        }
        $("#store-calendar-modal").show();
        modals.togglePageOverlay();
    },
}
